import displayUtils from './display.utils';
import comparableUtils from './comparable.utils';
import pixEvaluateUtils from '@/services/common/pixEvaluate.utils.js';
import pixUtils from '@/services/common/pix.utils.js';
import paramListConsts from '@/consts/paramList.const';
import store from '@/store/index.js';

export default {
  getComparableToPopUp(comparable, config, isDual, { langCode, userDateFormat, fallbackText }) {
    const params = { currentLang: langCode.toUpperCase(), userDateFormat, fallbackText };

    const comparableToPopUp = { ...comparable, child: this.getObjectToPopUp(comparable, config.childConfiguration, params) };
    let getLocality;

    if (isDual) {
      comparableToPopUp.parent = this.getObjectToPopUp(comparable.ParentInfo, config.parentConfiguration, params);
      comparableToPopUp.isDual = isDual;
      comparableToPopUp.parent.header = comparableToPopUp.parent.attributesList.shift();
      comparableToPopUp.parent.documents = [...comparableToPopUp.child.documents];
      getLocality = pixUtils.getFieldValue('Locality', comparable?.ParentInfo, null, null, langCode.toUpperCase());
      comparableToPopUp.fullAddress = this.getFullAddress(comparable?.ParentInfo, getLocality);
    } else {
      getLocality = pixUtils.getFieldValue('Locality', comparable, null, null, langCode.toUpperCase());
      comparableToPopUp.child.header = comparableToPopUp.child.attributesList.shift();
      comparableToPopUp.fullAddress = this.getFullAddress(comparable, getLocality);
    }

    return comparableToPopUp;
  },

  getFullAddress(comparable, getLocality) {
    const Locality = getLocality ? `${getLocality},` : '';
    const StreetNameAndNumber = comparable?.StreetNameAndNumber ? `${comparable.StreetNameAndNumber},` : '';
    const CityAddress = comparable?.CityAddress ? `${comparable.CityAddress},` : '';
    const State = comparable?.State ? `${store.getters['paramListModule/getValueDescByParamId'](paramListConsts.pixResearchComparablePopupState, comparable.State)},` : '';
    const PostalCode = comparable?.PostalCode ? `${comparable.PostalCode}` : '';
    return `${StreetNameAndNumber} ${Locality} ${CityAddress} ${State} ${PostalCode}`.replace(/,\s*$/, '');
  },

  getObjectToPopUp(comparable, configuration, params) {
    displayUtils.groupItemsInTheSameGridSlot(configuration);

    const attributes = [];

    configuration.forEach((configItem) => {
      const comparableObject = displayUtils.generateCommonObject(comparable, configItem, false, params);

      if (comparableObject && pixEvaluateUtils.evalConditions(configItem.Conditions, comparable, 'EN', null)) {
        comparableObject.label = configItem.MetricDescription;
        attributes.push(comparableObject);
      }
    });

    const attributesList = [];

    attributes.forEach((attribute) => {
      if (!attribute.inSameRow) {
        attributesList.push(attribute);
      } else {
        attributesList[attributesList.length - 1].values.push(attribute);
      }
    });
    const uniqueId = comparable.id || comparable.SourceId || comparable.RowId;
    const isProperty = !!comparable.attributes && !comparable.Features;
    const documents = isProperty ? comparable.documents : comparableUtils.getVisibleImages(comparable) ?? [];

    return { ...comparable, attributesList, uniqueId, documents, isProperty, comparableStatus: comparable.ComparableStatus, brochureDocUrl: comparable.BrochureDocUrl, BasketId: comparable.basketId ?? comparable.BasketId };
  },
};
